export const filter = {
  SET_APPLIED_FILTERS: 'SET_APPLIED_FILTERS',
  SET_CONFIG: 'SET_CONFIG',
  SET_APPLIED_FILTER_VALUES: 'SET_APPLIED_FILTER_VALUES',
  SET_DYNAMIC_OPTIONS: 'SET_DYNAMIC_OPTIONS',
  RESET_FILTERS: 'RESET_FILTERS',
  SET_FILTER_LOADING: 'SET_FILTER_LOADING',
  SET_FILTER_ERROR: 'SET_FILTER_ERROR'
};
